import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import Header from '../../components/layout/Header'
import Footer from '../../components/layout/Footer'
import Button from '../../components/common/Button'
import Input from '../../components/common/Input'
import { validateLoginForm, hasErrors } from '../../utils/validation'
import './Auth.css'

const Login = () => {
  const navigate = useNavigate()
  const { login } = useAuth()
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  })
  const [fieldErrors, setFieldErrors] = useState({})
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({ ...prev, [name]: value }))
    // Clear the error for the field being edited + any general error.
    setFieldErrors((prev) => ({ ...prev, [name]: undefined }))
    setError('')
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')

    const validationErrors = validateLoginForm(formData)
    if (hasErrors(validationErrors)) {
      setFieldErrors(validationErrors)
      return
    }
    setFieldErrors({})
    setLoading(true)

    try {
      const result = await login(formData.email.trim(), formData.password)
      if (result.success) {
        navigate('/')
      } else {
        // Client-side validation already covers empty/invalid fields, so a
        // failure here is a credentials/server issue → show the backend message
        // (e.g. "اسم المستخدم أو كلمة المرور غير صحيحة").
        setError(result.message || 'فشل تسجيل الدخول')
      }
    } catch (err) {
      setError('حدث خطأ أثناء تسجيل الدخول')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-page">
      <Header />
      <main className="auth-main">
        <div className="auth-container">
          <div className="auth-card">
            <h1 className="auth-title">تسجيل الدخول</h1>
            <p className="auth-subtitle">مرحباً بك مرة أخرى</p>

            <form onSubmit={handleSubmit} className="auth-form" noValidate>
              <Input
                label="البريد الإلكتروني"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                error={fieldErrors.email}
                fullWidth
              />

              <Input
                label="كلمة المرور"
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                error={fieldErrors.password}
                fullWidth
              />

              {error && <div className="auth-error">{error}</div>}

              <div className="auth-actions">
                <Link to="/forgot-password" className="auth-link">
                  نسيت كلمة المرور؟
                </Link>
              </div>

              <Button
                type="submit"
                variant="primary"
                size="lg"
                fullWidth
                loading={loading}
                disabled={loading}
              >
                تسجيل الدخول
              </Button>

              <div className="auth-footer">
                <span>ليس لديك حساب؟</span>
                <Link to="/register" className="auth-link-primary">
                  إنشاء حساب جديد
                </Link>
              </div>
            </form>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}

export default Login

